import React, { useState } from 'react'
import Sidebar from '../SideBar/index'
import Index2 from '../Navbar2/index2'
import "./Hero6.css"

const HeroSection6 = () => {
   const [isOpen, setIsOpen] = useState(false)
  
    const toggle = () => {
      setIsOpen(!isOpen)
    }
  return (
    <div className='HeroContainer6'>
      <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='HeroBg6'>
          <Index2 toggle={toggle}/>
        </div>
    </div>
  )
}

export default HeroSection6